import { InvoiceDetailsView } from "@portal/BaseComponents/DetailsView/InvoiceDetailsView/InvoiceDetailsView";
import { DisputeLists } from "@portal/Components/Portal/PotalTabs/Disputes/DisputeLists";
import { DisputeFilters } from "@portal/Components/Portal/PotalTabs/Disputes/Filters/DisputeFilters";
import { useFormats } from "@portal/hooks/use-formats";
import { Provider } from "jotai";
import { DisputeDetails } from "../DisputeDetails/DisputeDetails";
import { usePrivileges } from "@portal/hooks/use-privilleges";

function DisputeListPage() {
  const { extra } = useFormats();
    const { getCFPrivileges } =
    usePrivileges();
  return (
    <>
      <Provider>
        <DisputeFilters />
        <DisputeLists extra={extra}    actionPrivileges={{
            customField: getCFPrivileges("CUSTOM_FIELD_LIST_VIEW"),
          }} />
      </Provider>
      <DisputeDetails />
      <InvoiceDetailsView />
    </>
  );
}

export { DisputeListPage };
